import { msalConfig } from "../config/MsalConfig";

export const saveToStorage = (key: string, value: string) => {
    // Fetch user details
    if (msalConfig.cache.cacheLocation === 'localStorage') {
        localStorage.setItem(key, value); // Store token in local storage
    } else {
        sessionStorage.setItem(key, value); // Store token in session storage
    }
}
